import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import "./css/UltimoRecuerdo.css";

type Recuerdo = {
    imageUrl: string;
    location: string;
    date: string;
};

const UltimoRecuerdo: React.FC = () => {
    const [recuerdo, setRecuerdo] = useState<Recuerdo | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const cargarUltimoRecuerdo = async () => {
            const q = query(
                collection(db, "photos"),
                orderBy("createdAt", "desc"),
                limit(1)
            );

            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const data = snapshot.docs[0].data();

                setRecuerdo({
                    imageUrl: data.url,
                    location: data.text2,
                    date: data.text1,
                });
            }
        };

        cargarUltimoRecuerdo();
    }, [recuerdo]);

    if (!recuerdo) return null;

    return (
        <div
            className="ultimo-recuerdo"
            onClick={() => navigate("/galeria")}
            role="button"
        >
            <div className="recuerdo-img">
                <img src={recuerdo.imageUrl} alt="Último recuerdo" />
            </div>

            <div className="recuerdo-info">
                <span className="recuerdo-title">🕒 Último recuerdo añadido</span>
                <span className="recuerdo-location">📍 {recuerdo.location}</span>
                <span className="recuerdo-date">{recuerdo.date}</span>
            </div>
        </div>
    );
};

export default UltimoRecuerdo;
